import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';

@Component({
  selector: 'ideal-product-is-canadian',
  imports: [],
  templateUrl: './product-is-canadian.component.html',
  styleUrl: './product-is-canadian.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[hidden]': 'isLoading() ? true : !isCanadian()',
  },
})
export class ProductIsCanadianComponent extends CommonProductDetailsComponentBase {
  protected readonly isLoading = this.productDetails.loading;
  // protected readonly isCanadian = computed(() => true);
  protected readonly isCanadian = computed(() => this.productDetails()?.canadian ?? false);
}
